import axios from 'axios'

export default {
    namespaced: true,
    state: {
        recreationTypes: []
    },
    getters: {
        GET_SELECT_LIST(state) {
            return state.recreationTypes.map((item) => {
                return {text: item.name, value: item.id}
            })
        },
    },
    mutations: {
        FETCH_TYPES(state, types) {
            state.recreationTypes = types
        },
        ADD_TYPES(state, type) {
            state.recreationTypes.push(type)
        },
        EDIT_TYPES(state, type) {
            const index = state.recreationTypes.findIndex(
                item => item.id === type.id
            )
            Object.assign(state.recreationTypes[index], type)
        },
        DEL_TYPES(state, type) {
            const index = state.recreationTypes.findIndex(
                item => item.id === type.id
            )
            state.recreationTypes.splice(index, 1)
        }
    },
    actions: {
        add({commit, dispatch}, data) {
            return axios.post(
                '/api/manager/recreation/add',
                data
            ).then(({data}) => {
                commit('ADD_TYPES', data.data)
            }).catch((error) => {
                dispatch('checkUnauthenticated', error, { root: true })
            })
        },
        edit({commit, dispatch}, editedItem) {
            return axios.put(
                '/api/manager/recreation/edit/' + editedItem.id,
                editedItem
            ).then(({data}) => {
                commit('EDIT_TYPES', data.data)
            }).catch((error) => {
                dispatch('checkUnauthenticated', error, { root: true })
            })
        },
        delete({commit, dispatch, state}, itemId) {
            return axios.delete(
                '/api/manager/recreation/dell/' + itemId
            ).then(({data}) => {
                commit('DEL_TYPES', data.data)
            }).catch((error) => {
                dispatch('checkUnauthenticated', error, { root: true })
            })
        },
        fetch({commit, dispatch, state}) {
            if (!state.recreationTypes.length) {
                commit('TOGGLE_PRELOADER', true, {root: true})
                axios.post(
                    '/api/manager/recreation/list'
                ).finally(() => {
                    commit('TOGGLE_PRELOADER', false, {root: true})
                }).then(({data}) => {
                    commit('FETCH_TYPES', data.data)
                }).catch((error) => {
                    dispatch('checkUnauthenticated', error, { root: true })
                })
            }
        }
    }
}
